import countryJson from '@/assets/countries.json';
import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';
import Vue from 'vue';


export const MODAL_NAME = {
  CREATE: 'create',
  EDIT_DETAILS: 'editDetails',
  EDIT_CONTACT: 'editContact',
  EDIT_PAYMENT: 'editPayment',
  EDIT_ADDRESS: 'editAddress',
  ADD_CONTACT: 'addContact',
  ADD_ADDRESS: 'addAddress',
  SEND_UPDATE_DETAILS: 'sendUpdateDetails',
}

const state = {
  item: null,
  items: [],
  modals: {
    create: false,
    editDetails: false,
    editContact: false,
    editPayment: false,
    editAddress: false,
    addContact: false,
    addAddress: false,
  },
  refresh: false
};

const getters = {
  getSupporter: state => state.item,
  getSupporters: state => state.items,
  refresh: state => state.refresh,
  isOpen: (state) => (modalName) => state.modals[modalName]
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
  open(state, modalName) {
    Vue.set(state.modals, modalName, true);
  },
  close(state, modalName) {
    Vue.set(state.modals, modalName, false);
  },
  refresh(state) {
    Vue.set(state, 'refresh', !state.refresh);
  },
};

const actions = {
  get(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/supporters/get${queryParams}`);
  },
  getCountryCodesByCountries(state, countries) {
    const countryCodes = []
    for (const country of countries) {
      countryCodes.push(countryJson.find(code => code.name === country)?.code);
    }
    return new Set(countryCodes);
  },
  getUpdateDetails(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/supporters/update-details${queryParams}`);
  },
  search(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/supporters/search${queryParams}`);
  },
  create(state, payload) {
    return axios.post('/supporters', [payload])
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Create supporters - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  edit(state, payload) {
    return axios.patch(`/supporters`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit supporters - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  createUpdateAddress(state, payload) {
    return axios.post('/supporters/addresses', payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('create or update address - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  createUpdateDetails(state, payload) {
    return axios.post(`/supporters/update-details`, payload)
      .then(({ data }) => {
        console.log('data', data);
        // if (!!data.failures && data.failures.length > 0) {
        //   console.error('Edit supporters - ERROR - ', data.failures[0].error);
        //   throw data.failures;
        // } else {
        //   return data.successes;
        // }
      }).catch(err => { throw err });
  },
  sendUpdateDetailsEmail(state, payload) {
    return axios.post(`/supporters/update-details`, payload)
      .then(({ data }) => {
        console.log('data', data);
        // if (!!data.failures && data.failures.length > 0) {
        //   console.error('Edit supporters - ERROR - ', data.failures[0].error);
        //   throw data.failures;
        // } else {
        //   return data.successes;
        // }
      }).catch(err => { throw err });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};